import { render, staticRenderFns } from "./MainLedgerBookIn.vue?vue&type=template&id=51b1fa03&scoped=true"
import script from "./MainLedgerBookIn.vue?vue&type=script&lang=js"
export * from "./MainLedgerBookIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b1fa03",
  null
  
)

export default component.exports